import React from 'react';

const HealthCheckPattern = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="1440" height="467" viewBox="0 0 1440 467" preserveAspectRatio="none" fill="none">
      <g clip-path="url(#clip0_418_4680)">
        <rect width="1440" height="467" fill="white" />
        <g opacity="0.41">
          <rect x="927.982" y="58" width="25.646" height="69" fill="#DDCAEB" />
          <rect x="975" y="79.3716" width="25.646" height="69" transform="rotate(90 975 79.3716)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="715.496" y="152" width="37.9115" height="102" fill="#DDCAEB" />
          <rect x="785" y="183.593" width="37.9115" height="102" transform="rotate(90 785 183.593)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="876.248" y="105" width="18.9558" height="51" fill="#DDCAEB" />
          <rect x="911" y="120.796" width="18.9558" height="51" transform="rotate(90 911 120.796)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="787.664" y="45" width="25.2743" height="68" fill="#DDCAEB" />
          <rect x="834" y="66.062" width="25.2743" height="68" transform="rotate(90 834 66.062)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="571.248" y="58" width="18.9558" height="51" fill="#DDCAEB" />
          <rect x="606" y="73.7964" width="18.9558" height="51" transform="rotate(90 606 73.7964)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="704.248" width="18.9558" height="51" fill="#DDCAEB" />
          <rect x="739" y="15.7964" width="18.9558" height="51" transform="rotate(90 739 15.7964)" fill="#DDCAEB" />
        </g>
        <g opacity="0.41">
          <rect x="520.248" width="18.9558" height="51" fill="#DDCAEB" />
          <rect x="555" y="15.7964" width="18.9558" height="51" transform="rotate(90 555 15.7964)" fill="#DDCAEB" />
        </g>
        <path opacity="0.18" d="M873.696 346.434C710.552 293.078 218.589 354.643 -7 392.095V467H1440V2.69455C1277.39 -10.6446 1000.45 18.9068 1193.59 243.826C1386.72 468.744 1060.8 405.948 873.696 346.434Z" fill="#7F4A9B" />
      </g>
      <defs>
        <clipPath id="clip0_418_4680">
          <rect width="1440" height="467" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HealthCheckPattern;